<template>
  <div v-show="showComponent" class="object-dashboard">
    <!-- Sub Navbar -->
    <v-app-bar
        app
        clipped-left
        clipped-right
        class="mt-16 sub-app-bar"
        fixed
    >
      <v-row align="center">
        <v-col cols="1" md="3" lg="3">
          <div class="d-flex flex-row">
            <div >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn icon @click="$router.push(`/${$store.state.manager.bookModuleUrl}/buildings`)" v-bind="attrs" v-on="on">
                    <v-icon>arrow_back_ios</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('buttons:back')}}</span>
              </v-tooltip>
            </div>
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <p class="title">
                <v-tooltip v-if="building.cutName" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ building.cutName }}
                    </span>
                  </template>
                  {{ building.name }}
                </v-tooltip>
                <span v-else>{{ building.name }}</span>
              </p>
              <p class="subtitle" v-if="currentTab === 'dashboard'">{{ $t('common:dashboard') }}</p>
              <p class="subtitle" v-else-if="currentTab === 'roles'">{{ $t('common:role_plural') }}</p>
              <p class="subtitle" v-else-if="currentTab === 'facilities'">{{ $t('common:facility_plural') }}</p>
              <p class="subtitle" v-else-if="currentTab === 'finances'">{{ $t('book/building:common.finances') }}</p>
              <p class="subtitle" v-else-if="currentTab === 'analysis'">{{ $t('book/facility:cost-analysis.cost-analysis') }}</p>
            </div>
          </div>
        </v-col>
        <v-col cols="10" sm="9" md="6" lg="6">
          <div class="d-flex flex-row">
            <v-tabs
                v-model="currentTab"
                hide-slider
            >
              <v-tab to="#dashboard">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:dashboard')}}</span>
                <span v-else><v-icon>dashboard</v-icon></span>
              </v-tab>
              <v-tab to="#roles">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:role_plural')}}</span>
                <span v-else><v-icon>engineering</v-icon></span>
              </v-tab>
              <v-tab to="#facilities">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:facility_plural')}}</span>
                <span v-else><v-icon>account_tree</v-icon></span>
              </v-tab>
              <v-tab to="#finances">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/building:common.finances')}}</span>
                <span v-else><v-icon>account_balance</v-icon></span>
              </v-tab>
              <v-tab to="#analysis">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:cost-analysis.cost-analysis')}}</span>
                <span v-else><v-icon>payments</v-icon></span>
              </v-tab>
            </v-tabs>
          </div>
        </v-col>
        <v-col class="d-none d-md-flex"></v-col>
        <v-col cols="1" sm="2" md="2" xl="1" class="text-right d-none d-sm-flex">
          <p class="mb-0 pb-0 grey--text ml-auto">
            <v-icon color="grey">calendar_today</v-icon>
            {{ currentDate }}
          </p>
        </v-col>
      </v-row>

    </v-app-bar>

    <!-- Left Sidebar -->
    <BuildingFormSidebar
        ref="formSidebar"
        @save="updateForm"
        @setOwner="$refs.buildingFinancesTab.addCustomerToSelection($event)"
        @setOperator="$refs.buildingFinancesTab.addCustomerToSelection($event)"
    />

    <!-- Page content -->
    <div class="building-content-wrapper">
      <v-tabs-items v-model="currentTab">
        <!-- Dashboard-Tab -->
        <v-tab-item
            value="dashboard"
            eager
            class="pa-5"
        >
          <BuildingDashboardTab @addRole="addRole"/>
        </v-tab-item>

        <!-- Roles-Tab -->
        <v-tab-item
            value="roles"
            eager
            class="pa-5"
        >
          <BuildingRoleTab ref="buildingRoleTab"/>
        </v-tab-item>

        <!-- Facilities-Tab -->
        <v-tab-item
            value="facilities"
            eager
            class="pa-5"
        >
          <BuildingFacilityTab ref="buildingFacilityTab"/>
        </v-tab-item>

        <!-- Finances-Tab -->
        <v-tab-item
            value="finances"
            eager
            class="pa-5"
        >
          <BuildingFinancesTab ref="buildingFinancesTab" @save="updateForm"/>
        </v-tab-item>

        <!-- Cost-Analysis-Tab -->
        <v-tab-item
            value="analysis"
            eager
            class="pa-5"
        >
          <BuildingCostAnalysisTab ref="buildingCostAnalysisTab" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- Right Sidebar -->
    <BuildingQuickLinkSidebar
        ref="quickLinkSidebar"
        @quickLinkAction1="addRole"
        @quickLinkAction2="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities?building=${$route.params.id}`)"
        @quickLinkAction3="$router.push(`/${$store.state.manager.bookModuleUrl}/buildings/edit/${$route.params.id}#finances`)"
    />
  </div>
</template>
<script>

import BuildingService from '@/modules/book/services/building-service';

import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';

import Building from '@/modules/book/data/building';

import BuildingFormSidebar from './BuildingFormSidebar'
import BuildingQuickLinkSidebar from './BuildingQuickLinkSidebar'
import BuildingDashboardTab from './tabs/BuildingDashboardTab';
import BuildingRoleTab from './tabs/BuildingRoleTab';
import BuildingFacilityTab from './tabs/BuildingFacilityTab';
import BuildingFinancesTab from './tabs/BuildingFinancesTab';
import DateUtils from '@/modules/core/services/date-utils';
import CustomerService from '@/modules/core/services/customer-service';
import Customer from '@/modules/core/data/customer';
import {mapGetters} from 'vuex';
import BuildingCostAnalysisTab from '@/modules/book/views/cost-analysis/building/BuildingCostAnalysisTab';

export default {
  name: "BuildingForm",
  components: {
    BuildingCostAnalysisTab,
    BuildingFormSidebar,
    BuildingQuickLinkSidebar,
    BuildingDashboardTab,
    BuildingRoleTab,
    BuildingFacilityTab,
    BuildingFinancesTab
  },
  data() {
    return {
      building: new Building(),
      currentTab: null,

      isFetchingBuilding: true,

      currentDate: null,
      customerOfloggedInUser: new Customer()
    };
  },
  computed: {
    showComponent() {
      if(this.isFetchingBuilding) {
        return false
      } else {
        return true;
      }
    },
    ...mapGetters('auth', ['isAdmin']),
  },
  methods: {
    updateForm(building, formSidebarValid) {

      if (!this.isAdmin
          && !Utils.checkCustomerWithDescendentsForBuilding(this.customerOfloggedInUser, building)) {
        Utils.showFailureSnackbar(this.$t('book/building:building.form-sidebar.snackbar.customer'))
        return;
      }

      if(!formSidebarValid || !this.$refs.buildingFinancesTab.getFormValidation()) {
        Utils.showWarningSnackbar(this.$t('snackbar:empty-fields'))

        if (!this.$refs.buildingFinancesTab.getFormValidation() && this.currentTab !== "finances") {
          this.currentTab = "finances";
        }

        return;
      }

      building.billingPersonName = this.$refs.buildingFinancesTab.building.billingPersonName;
      building.billing_street = this.$refs.buildingFinancesTab.building.billing_street;
      building.billing_city = this.$refs.buildingFinancesTab.building.billing_city;
      building.billing_zip = this.$refs.buildingFinancesTab.building.billing_zip;

      BuildingService.putToAPI(building,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:building')}));
          this.$router.push(this.$store.state.book.routes.lastMainRoute)
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:building')}))
        }
      );
    },

    addRole(){
      if(this.$route.hash !== '#roles') {
        this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/buildings/edit/${this.$route.params.id}#roles`);
      }

      this.$refs.buildingRoleTab.openDialog();
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(from.hash) {
        vm.$store.commit('book/routes/storeLastMainRoute', from.path + from.hash);
      } else {
        vm.$store.commit('book/routes/storeLastMainRoute', from.path);
      }

      // open role dialog if according action btn was clicked in buildings overview
      if(to.hash === '#roles' && from.path === '/buildings') {
        vm.$refs.buildingRoleTab.openDialog();
      }
    });
  },
  created() {
    CustomerService.readProfileFromAPI(
        (res) => {
          this.customerOfloggedInUser = DataUtils.parseDataToSingleObject(res.data, Customer);
        },
        (error) => {
          Utils.showWarningSnackbar(this.$t('book/building:overview.form.snackbar.customer-load-failure'))
          this.$logger.error(error);
        }
    )

    BuildingService.readFromAPI(this.$route.params.id,
      (res) => {
        this.building = DataUtils.parseDataToSingleObject(res.data, Building);

        if(this.building.name.length > 20) {
          this.building.cutName = Utils.cropText(this.building.name, 20, false)
        }

        this.$refs.formSidebar.setFormData(this.building, res.data.deleted)
        this.$refs.buildingFacilityTab.building = this.building;
        this.$refs.buildingFinancesTab.building = this.building;

        this.isFetchingBuilding = false;
      },
      (error) => {
        this.$logger.error(error);
        this.$router.push('/404')
      }
    )

    this.currentDate = DateUtils.getCurrentDateAsDEString();
  }
};
</script>
